import React, { useCallback, useEffect, useState } from 'react';
import { Col, List, Row, Skeleton } from 'antd';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import { Button, Heading, Layout, Section, CardAdd, MobileTopAdd, CardSkelton } from 'components';
import FilteringPanel from './_FilteringPanel';
import TutorCard from 'components/common/TutorCard';
import SelectInput from 'components/forms/SelectInput';
import { t, Trans } from '@lingui/macro';
import { withI18n } from '@lingui/react';
import { country } from 'App';
import { countryMap } from 'helpers/countryMapping';
import { useTutors } from 'helpers/hooks/data';
import { TOTAL_USER_SHOW } from '../../../helpers/constants';
import { queryFetchCities } from 'queries/data';
import { useMutation, useQuery } from 'react-apollo';
import { client, newClient } from 'helpers';
import { Content } from '@candulabs/react-sdk';
import InfiniteScroll from 'react-infinite-scroller';

const TutorList = styled(List)`
	.ant-row {
		display: flex;
		flex-wrap: wrap;
		.ant-col {
			margin-bottom: 0;
			.ant-list-item {
				height: 350px;
			}
		}
	}
`;
const programmeClient = newClient('programme');
function Marketplace({ location, history, i18n }) {
	const initialPriceRange = (country && countryMap[country].pricePerHourRange.range) || [];
	const [tutorLength, setTutorLength] = useState(0);
	const initialValues = {
		keywords: '',
		curriculums: 0,
		subjects: 0,
		alphabet: 0,
		recently: 0,
		pricePerHour: 0,
		rating: 0,
		testimonial: 0,
		location: '',
		page: 1,
		limit: TOTAL_USER_SHOW,
		price_range: { startPrice: initialPriceRange[0], endPrice: initialPriceRange[1] },
		fromWhere: 'CategoryListingPage'
	};

	const [formValues, setFormValues] = useState(initialValues);
	const { data: city = {} } = useQuery(queryFetchCities, { client: programmeClient, variables: { country } });
	const [searchUsers, { loading, data }] = useTutors();
	const [users, setUsers] = useState(data);
	const [hasMore, sethasMore] = useState(false);
	const [num, setnum] = useState(0)
	const citiesData = city.getProgrammeCityList || [];
	const citiesoption = citiesData.map(item => ({ value: item.name, label: item.name }));

	const handleSortUsers = value => {
		const recently = value === 'recently' ? 1 : 0;
		const alphabet = value === 'alphabet' ? 1 : 0;
		const pricePerHour = value === 'pricePerHour' ? 1 : 0;
		const rating = value === 'totalrating' ? 1 : 0;
		const testimonial = value === 'totalreviews' ? 1 : 0;
		const values = {
			...formValues,
			country,
			recently,
			alphabet,
			pricePerHour,
			rating,
			testimonial,
			page: 1,
			limit: TOTAL_USER_SHOW * (formValues.page - 1)
		};
		setUsers({ tutors: [] });
		setTutorLength(0);
		setnum(0);
		setFormValues(prev => ({ ...prev, country, recently, alphabet, pricePerHour, rating, testimonial }));
		searchUsers({ variables: values });
	};

	const handleSearchFilter = useCallback(
		name => e => {
			const { price_range } = formValues;
			setFormValues(prev => ({ ...prev, [name]: e.target.value }));
			setUsers({ tutors: [] });
			setTutorLength(0);
			setnum(0);
			const values = {
				...formValues,
				[name]: e.target.value,
				page: 1,
				limit: TOTAL_USER_SHOW * formValues.page,
				price_range: { startPrice: price_range.startPrice, endPrice: price_range.endPrice }
			};

			if (window.location.search !== '') history.push(`/${country}/lifelong/browse`);
			searchUsers({ variables: values });
		},
		[formValues, history, searchUsers, setFormValues]
	);

	const handleChangeSlider = useCallback(
		value => {
			setFormValues(prev => ({ ...prev, price_range: { startPrice: value[0], endPrice: value[1] } }));
			setUsers({ tutors: [] });
			setTutorLength(0);
			setnum(0);
			const values = {
				...formValues,
				page: 1,
				limit: TOTAL_USER_SHOW * formValues.page,
				price_range: { startPrice: value[0], endPrice: value[1] }
			};

			if (window.location.search !== '') history.push(`/${country}/lifelong/browse`);
			searchUsers({ variables: values });
		},
		[formValues, history, searchUsers, setFormValues]
	);

	const handleClickTutor = item => {
		// 	onMarketplace.setValueFromMarketplace({
		// 		keywords: formValues.keywords,
		// 		subjects: subjectLabel,
		// 		curriculums: curriculumLabel,
		// 	})
		window.open(`/${country}/${item.token}--${item.pvid}--${item.firstName}--${item.lastName}`);
	};

	useEffect(() => {
		// if (subjectParams) {
		// 	searchUsers({ variables: { ...formValues, subjects: Number(subjectParams) } })
		// } else if (keywordParams) {
		// 	searchUsers({ variables: { ...formValues, keywords: keywordParams } })
		// } else searchUsers({ variables: formValues })
		searchUsers({ variables: formValues });
	}, [searchUsers]);

	useEffect(() => {
		if (data.tutors.length != 0) {
			let tutorsWithAdd = [];
			let len = data.tutors.length;
			for (let i = num; i < Math.min(20 + num, len); i += 5) tutorsWithAdd = tutorsWithAdd.concat(data.tutors.slice(i, i + 5), [{ type: 'ad' }]);
			tutorsWithAdd.pop();
			setUsers({ ...data, tutors: users.tutors.concat(tutorsWithAdd) });
			setnum(prevNum => prevNum + 20)
			setTutorLength(len);
			sethasMore(true)
		}
	}, [data]);
	const handleLoadMore = () => {
		const values = { ...formValues, country, page: formValues.page + 1 };
		setFormValues(prev => ({ ...prev, country, page: formValues.page + 1 }));
		if (num >= tutorLength) {
			sethasMore(false)
		} else {
			searchUsers({ variables: values });
		}
	};
	// const loadMore =
	// 	users.totalPages && users.page !== users.totalPages ? (
	// 		<div
	// 			style={{
	// 				textAlign: 'center',
	// 				marginTop: 12,
	// 				height: 32,
	// 				lineHeight: '32px'
	// 			}}>
	// 			<Button onClick={handleLoadMore} type="primary" size="medium">
	// 				Load more
	// 			</Button>
	// 		</div>
	// 	) : null;
	return (
		<Layout>
			<Section>
				<Content slug="cudy-lifelong-banners" />
				<Row justify="center">
					<MobileTopAdd />
				</Row>
				<Row gutter={48}>
					<Col lg={6} style={{ margin: '0 auto' }}>
						<FilteringPanel
							onUsers={{ handleSearchFilter, handleChangeSlider }}
							onFormValues={{ formValues, setFormValues }}
							location={{ location, history }}
							citiesoption={citiesoption}
						/>
					</Col>
					<Col lg={18}>
						<Section noPadding className="mb2em smooth-scroll">
							<Row type="flex" justify="space-between" align="middle">
								<Col lg={12}>
									<Heading
										content={<Trans>Searches</Trans>}
										subheader={
											<span>
												Showing&nbsp;
												<strong>{tutorLength} tutors</strong>
											</span>
										}
										level={4}
									/>
								</Col>
								<Col lg={12} xs={12} style={{ textAlign: 'right' }}>
									<Row gutter={16} type="flex" justify="end">
										<Col lg={12}>
											<SelectInput
												independent
												name="sort"
												defaultvalue={<Trans>Sort by...</Trans>}
												options={[
													{ value: 'Sort by...', label: <Trans>Sort by...</Trans> },
													{ value: 'recently', label: <Trans>Recently Added</Trans> },
													{ value: 'alphabet', label: <Trans>Alphabet</Trans> },
													{ value: 'pricePerHour', label: <Trans>Price Per Hour</Trans> },
													{ value: 'totalrating', label: <Trans>Rating</Trans> },
													{ value: 'totalreviews', label: <Trans>Reviews</Trans> }
												]}
												onChange={handleSortUsers}
												placeholder={i18n._(t`Sort by...`)}
											/>
										</Col>
									</Row>
								</Col>
							</Row>
						</Section>
						<Section noPadding>
							{users.tutors.length != 0 && (
								<InfiniteScroll
									pageStart={1}
									loadMore={handleLoadMore}
									hasMore={!loading && hasMore}
									useWindow={true}
									initialLoad={false}
								>
									<TutorList
										dataSource={users.tutors}
										grid={{ gutter: 48, xs: 1, sm: 2, md: 3, lg: 3, xl: 4 }}
										renderItem={(item, index) => {
											return (
												<>
													{item?.type !== 'ad' ? (
														<List.Item key={item.pvid}>
															<TutorCard {...item} onClick={() => handleClickTutor(item)} />
														</List.Item>
													) : (
														<div style={{ marginBottom: 20 }}>
															<CardAdd />
														</div>
													)}
												</>
											);
										}}
									/>
								</InfiniteScroll>
							)}
							{loading && <CardSkelton />}
						</Section>
					</Col>
				</Row>
			</Section>
		</Layout>
	);
}

export default withI18n()(withRouter(Marketplace));
